import store from '../store';

export const validRoles = ['ADMIN', 'OPERATIONS', 'ENGINEERING', 'SUPER ADMIN'];

export default {
  isAdmin() {
    return Number(store.state.userData.role) === 1;
  },
  isGt() {
    return Number(store.state.userData.id) === 1253797; // GT BANK
  },
  isMtn() {
    return Number(store.state.userData.id) === 492235;
  },
};
